<style lang="scss" scoped>
  @import '../../../sass/variables';

  #lead-modal {
    #options-button {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .modal-dialog {
      width: 100%;
      max-width: 1100px;
      color: $salesflow-font-dark;
      border-radius: 16px;

      .salesflow-btn {
        margin-top: 8px;
        padding: 8px 24px;
      }

      .modal-main-content {
        width: 80%;
        overflow-y: scroll;
        border-right: 4px solid transparent;
        padding: 40px 16px 0px;
        border-bottom-right-radius: 16px;
      }

      .modal-sidebar {
        width: 20%;
        overflow-y: hidden;
        overflow-x: hidden;
        padding: 40px 40px 56px;
        color: $salesflow-font-dark;
        font-size: 0.75rem;
        line-height: 125%;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: 1px solid $salesflow-outline-gray-medium;
        border-bottom-left-radius: 16px;
      }

      .modal-content {
        background-color: transparent;
        border-radius: 16px;

        .modal-body {
          min-height: 380px;
          padding: 0px;
          background-color: transparent;

          .col-left {
            z-index: 2;
            padding-left: 20px;
            padding-right: 30px;
          }

          .col-right {
            padding-left: 0px;
            margin-left: -25px;
          }
        }
      }
    }
  }

  .media-body.act-media-body iframe {
    height: 50vh;
    min-height: 300px;
  }

  .subject, .search-model {
    border: 1px solid $salesflow-outline-gray-medium;
  }
</style>
<template>
  <section class="lead-activity">
    <div class="entry message">
      <div class="media act-media">
        <div class="media-body act-media-body">
          <div class="activity-content">
            <div class="form-group row">
              <div class="col-md-6 px-0 pr-md-10px mb-15px m-md-0">
                <input
                  class="form-control w-100 subject"
                  type="text"
                  v-model="messageForm.subject"
                  :placeholder="__('Assunto')"
                  @input="onInputSubject"
                ><span
                  class="form-text text-danger"
                  v-show="messageForm.errors.has('subject')"
                >{{ messageForm.errors.get('subject') }}</span>
              </div>
              <div class="col-md-6 px-0 pl-md-10px">
                <div class="search-model">
                  <Multiselect
                    id="search-model"
                    label="title"
                    track-by="id"
                    v-model="emails.selected"
                    :placeholder="__('Digite para pesquisar e-mail...')"
                    open-direction="bottom"
                    :loading="searching"
                    :options="emails.models"
                    :multiple="false"
                    :searchable="true"
                    :show-labels="false"
                    :hide-selected="true"
                    :preserve-search="true"
                    :internal-search="false"
                    :show-no-options="false"
                    @select="selectModel"
                    @search-change="searchModel"
                    @input="onInputTitle"
                  >
                    <span slot="noResult">{{ __('Nenhum item encontrado.') }}</span>
                    <template
                      slot="option"
                      slot-scope="props"
                    >
                      <div><span class="d-block">{{ props.option.title || props.option.subject }}</span><small>{{ props.option.title ? props.option.subject : null }}</small></div>
                    </template>
                  </Multiselect>
                </div>
              </div>
            </div>
          </div>
          <div class="activity-content">
            <div class="form-group form-control activity-edit">
              <Tinymce
                v-model="messageForm.content"
                :config="tinymce"
                variables="variables"
                @input="onInputMessage"
              />
            </div><span
              class="form-text text-danger"
              v-show="messageForm.errors.has('content')"
            >{{ messageForm.errors.get('content') }}</span>
          </div>
          <div class="form-actions d-flex align-items-center mt-2">
            <div
              class="d-inline w-50"
              v-if="tokens.length > 1"
            >
              <select
                class="form-control"
                v-model="messageForm.token_id"
              >
                <option
                  :value="token.id"
                  :key="token.id"
                  v-for="token in tokens"
                  v-text="token.metadata.email"
                />
              </select><span
                class="form-text text-danger"
                v-show="messageForm.errors.has('email')"
              >{{ messageForm.errors.get('email') }}</span>
            </div>
            <div class="d-inline ml-auto">
              <button
                class="btn btn-box-success mr-2"
                type="submit"
                :disabled="busy"
                @click="send(true)"
                v-if="tokens.length"
              >
                <span v-if="messageForm.busy && viaGmail"><i class="fa fa-circle-o-notch fa-spin" /></span><span v-else>{{ __('Enviar via Gmail') }}</span>
              </button>
              <button
                class="btn btn-box-success"
                type="submit"
                :disabled="busy"
                @click="send()"
              >
                <span v-if="messageForm.busy && ! viaGmail"><i class="fa fa-circle-o-notch fa-spin" /></span><span v-else>{{ __('Enviar via e-mail') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div><span class="clearfix" />
    <div v-if="loading">
      <i class="fa fa-circle-o-notch fa-spin" />
    </div>
    <div
      class="activity-list"
      v-if="messages.length"
    >
      <div
        :key="message.id"
        v-for="(message, index) in messages"
      >
        <div class="media act-media d-flex">
          <div class="media-body act-media-body">
            <div class="px-20px mb-2">
              <span
                class="badge badge-box badge-border badge-message-via mr-2"
                v-if="message.via"
              ><span v-if="message.via === 'wassenger'">Whatsapp</span><span v-else>{{ message.via | capitalize }}</span></span><span
                class="mr-2"
                v-if="message.subject"
              ><b>{{ __('Assunto:') }}</b> {{ message.subject }}</span><span v-if="! message.content"><span v-if="webViewUrl(message)"><a
                :href="webViewUrl(message)"
                target="_blank"
              ><i>{{ __('Clique para ver o conteúdo') }}</i></a></span><span v-else><i>{{ __('Conteúdo indisponível') }}</i></span></span>
            </div>
            <div
              class="px-20px"
              v-if="message.content"
            >
              <iframe
                class="frame-message"
                width="100%"
                frameborder="0"
                :srcdoc="message.content"
                v-if="message.via == 'email' || message.via == 'gmail'"
              />
              <LeadMessageContent
                :message="message"
                v-else
              />
            </div><small
              class="px-20px"
              v-if="message.sent_at"
            ><span v-b-tooltip.right="formatDate(message.sent_at.date || message.sent_at)"><i class="fa fa-clock-o" /> {{ (message.sent_at.date || message.sent_at) | ago }}</span></small>
          </div>
        </div>
        <hr
          class="mx-20px"
          v-if="index != messages.length - 1"
        >
      </div>
    </div>
  </section>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';
import Swal from 'sweetalert2';

function messageForm () {
  return {
    type: 'write',
    via: 'email',
    subject: '',
    content: '',
    token_id: '',
  };
}

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: ['user', 'hash'],

  created () {
    this.searchModel();
  },

  mounted() {
    window.addEventListener('beforeunload', (event) => {
      if (this.hasUnsavedChanges) {
        event.preventDefault();
        event.returnValue = '';
      }
    });
    document.addEventListener('click', (event) => {
      const target = event.target.closest('a, button');
      if (target && target.hasAttribute('data-ignore-unsaved-check')) {
        return;
      }
      if (target && target.tagName === 'A' && this.hasUnsavedChanges) {
        event.preventDefault();
        this.handleBeforeUnload(() => {
          window.location.href = target.href;
        });
      }
    });
    this.getMessages();
    this.getTokens();
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    document.removeEventListener('click', this.handleBeforeUnload);
  },

  data () {
    return {
      hasUnsavedChanges: false,
      tokens: [],
      messages: [],
      loading: true,
      sending: false,
      viaGmail: false,
      searching: false,
      title: null,
      subject: null,
      content: null,
      emails: {
        selected: null,
        models: [],
      },
      tinymce: {
        height: 100,
        inline: true,
        plugins: 'legacyoutput,variables,table,media,image,textcolor,link,fullpage',
        toolbar1: 'styleselect | fontselect fontsizeselect forecolor backcolor | bold italic strikethrough',
        toolbar2: 'alignleft aligncenter alignright alignjustify | bullist numlist | link image variables',
      },
      messageForm: new BulldeskForm(messageForm()),
    };
  },

  computed: {
    busy () {
      return messageForm.busy
          || this.messageForm.subject === ''
          || this.messageForm.content === '';
    },
  },

  methods: {
    handleBeforeUnload(continueNavigation) {
      if (this.hasUnsavedChanges) {
        Swal.fire({
          iconHtml: '<img src="/build/icons/question-circle.svg" style="width: 72px; height: 72px;">',
          title: this.__('Deseja realmente sair?'),
          html: `
            <div class="container-basic mb-3">
              <span class="container-basic-title">${this.__('Existem alterações que não foram salvas.')}</span>
            </div>
          `,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.__('Sair'),
          cancelButtonColor: 'transparent',
          cancelButtonText: this.__('Cancelar'),
          showCancelButton: true,
          customClass: {
            container: 'container-delete-lead',
            confirmButton: 'salesflow-btn salesflow-btn-secondary',
            cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
            icon: 'no-border',
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.hasUnsavedChanges = false;
            if (typeof continueNavigation === 'function') {
              continueNavigation();
            }
          }
        });
      } else if (typeof continueNavigation === 'function') {
        continueNavigation();
      }
    },

    getMessages () {
      this.$http.get(`/lead/${this.hash}/message`)
        .then(({ data }) => {
          this.messages = data;
          this.loading = false;

          Vue.nextTick(() => setTimeout(() => this.updateIframesStyle(), 600));
        })
        .catch((error) => {
          // console.log(error.responseJSON);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getTokens () {
      this.$http.get('/user/token/google')
        .then(({ data }) => this.tokens = data)
        .then((tokens) => {
          if (tokens.length) {
            this.messageForm.token_id = tokens[0].id;
          }
        });
    },

    webViewUrl (message) {
      return message.metadata ? message.metadata.webview_url : '';
    },

    updateIframesStyle () {
      const frames = document.getElementsByClassName('frame-message');

      for (let i = 0; i < frames.length; i++) {
        this.setIframeStyle(frames[i]);
      }
    },

    setIframeStyle (el, retry = true) {
      const frame = el.contentDocument || el.contentWindow.document;
      const body = frame.querySelector('body');

      const {
        offsetHeight = 0,
      } = frame.querySelector('html') || {};

      const height = offsetHeight;

      body.style.fontFamily = "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";
      body.style.fontSize = '13px';

      if (frame.querySelector('.unsubscribe')) {
        frame.querySelector('.unsubscribe').classList.remove('unsubscribe');
      }

      if (retry && height === 0) {
        return setTimeout(() => this.setIframeStyle(el, false), 200);
      }

      el.height = Math.min(300, Math.max(height, 80));
    },

    selectModel (model) {
      if (model) {
        this.subject = model.subject;
        this.content = model.html || '';
        this.messageForm.subject = model.subject;
        this.messageForm.content = model.html || '';

        if (this.messageForm.content) {
          tinyMCE.activeEditor.setContent(this.messageForm.content);
        }
      }
    },

    searchModel (query = '') {
      if (query.length > 0 && query.length < 3) {
        return;
      }

      this.searching = true;

      const encodedQuery = encodeURIComponent(query.trim());
      this.$http.get(`/mail/search?query=${encodedQuery}`)
        .then(({ data }) => {
          this.emails.models = data;
        })
        .finally(() => {
          this.searching = false;
        });
    },

    send (viaGmail = false) {
      const { token_id } = this.messageForm;

      this.viaGmail = viaGmail;

      Http.post(`/lead/${this.hash}/message`, this.messageForm)
        .then((response) => {
          this.viaGmail = false;

          if (! response.user) {
            return Alert.error(this.__('Erro ao enviar mensagem. Verifique se o e-mail do lead é válido.'));
          }

          this.messages.unshift(response);
          Alert.success(this.__('Mensagem enviada!'));

          Bus.$emit('leadUpdated', response);

          this.content = null;
          this.subject = null;
          this.title = null;
          this.emails.selected = null;
          this.checkIfAnyFieldHasContent();
          tinyMCE.activeEditor.setContent('');

          this.messageForm = new BulldeskForm(messageForm());
          this.messageForm.token_id = token_id;

          Vue.nextTick(() => setTimeout(() => this.updateIframesStyle(), 1000));
        })
        .catch((error) => {
          console.log(error);

          if (error.message) {
            Alert.error(error.message);
          } else {
            Alert.error(this.__('Erro ao enviar mensagem. Verifique se o e-mail do lead é válido.'));
          }
        });
    },

    formatDate (date) {
      return dayjs(date).format('LDT');
    },

    onInputSubject(event) {
      this.subject = event.target.value;
      this.$nextTick(() => this.checkIfAnyFieldHasContent());
    },

    onInputTitle(event) {
      this.title = event;
      this.$nextTick(() => this.checkIfAnyFieldHasContent());
    },

    onInputMessage(content) {
      const plainText = content
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim();

      this.content = plainText;
      this.$nextTick(() => this.checkIfAnyFieldHasContent());
    },

    checkIfAnyFieldHasContent() {
      const hasSubject = this.subject && this.subject.trim() !== '';
      const hasTitle = this.title !== null;
      const hasContent = this.content && this.content.trim() !== '';

      this.hasUnsavedChanges = hasSubject || hasTitle || hasContent;

      if (this.hasUnsavedChanges) {
        this.$emit('message-changed', 'hasChanges');
      } else {
        this.$emit('message-changed', null);
      }
    },
  },
};
</script>
